'use strict'

const { VUE_APP_ORDERS_URL } = process.env

export default async ({ jwt, order }) => {
  const response = await fetch(`${VUE_APP_ORDERS_URL}/initOrder`, {
    method: 'POST',
    headers: {
      Authorization: jwt,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(order),
    timeout: 8000
  })
  if (!response.ok) throw (response.statusText)
  return await response.json()
}
